import React, { useEffect, useState } from "react";
import Navbar from "../../layouts/MainNavbar";
import { GetYear } from "../../utils/GetYear";
import Breadcrumb from "../../utils/Breadcrumb";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { GetAccess } from "../../utils/RolesandAccess";

function MainAdminSettings() {
  const location = useLocation();
  let pathFile = location.pathname;
  const [labelFile, setLabelFile] = useState("Company Info");

  let LinkItem = [
    {
      label: "Company Info",
      link: "/admin-settings/company-info",
    },
    {
      label: "Email Setup",
      link: "/admin-settings/email-setup",
    },
    {
      label: "User Management",
      link: "/admin-settings/user-managment",
    },
    {
      label: "Role",
      link: "/admin-settings/role",
    },
    {
      label: "User Role",
      link: "/admin-settings/user-role",
    },
    {
      label: "Standard Reset",
      link: "/admin-settings/standard-reset",
    },
    {
      label: "Action Log",
      link: "/admin-settings/action-log",
    },
    {
      label: "Vendor Management",
      link: "/admin-settings/vendor-management",
    },
    {
      label: "Certification Calendar Tracker",
      link: "/admin-settings/certification-calendar-tracker",
    },
    {
      label: "Subcription",
      link: "/admin-settings/subcription",
    },
    {
      label: "Department Type",
      link: "/admin-settings/department-type",
    },
    {
      label: "Backup & Restore",
      link: "/admin-settings/backup-restore",
    },
  ];

  useEffect(() => {
    if (location.pathname == `/admin-settings/company-info`) {
      setLabelFile("Company Info");
    } else if (location.pathname == `/admin-settings/email-setup`) {
      setLabelFile("Email Setup");
    } else if (location.pathname == `/admin-settings/user-managment`) {
      setLabelFile("User Management");
    } else if (location.pathname == `/admin-settings/role`) {
      setLabelFile("Role");
    } else if (location.pathname == `/admin-settings/user-role`) {
      setLabelFile("User Role");
    } else if (location.pathname == `/admin-settings/standard-reset`) {
      setLabelFile("Standard Reset");
    } else if (location.pathname == `/admin-settings/action-log`) {
      setLabelFile("Action Log");
    } else if (location.pathname == `/admin-settings/vendor-management`) {
      setLabelFile("Vendor Management");
    } else if (
      location.pathname == `/admin-settings/certification-calendar-tracker`
    ) {
      setLabelFile("Certification Calendar Tracker");
    } else if (location.pathname == `/admin-settings/subcription`) {
      setLabelFile("Subcription");
    } else if (location.pathname == `/admin-settings/department-type`) {
      setLabelFile("Department Type");
    } else if (location.pathname == `/admin-settings/backup-restore`) {
      setLabelFile("Backup & Restore");
    }
  }, [location.pathname]);
  return (
    <div className=" w-full h-full overflow-hidden">
      <div className=" w-full h-[60px]">
        <Navbar />
      </div>
      <div className="w-[100%] h-[calc(100vh-80px)]">
        <div className=" w-[92%] mx-auto">
          <Breadcrumb
            items={[
              {
                name: "Admin Settings",
              },
              {
                name: labelFile,
              },
            ]}
          />
        </div>
        <div className=" w-[97%] mx-auto h-[calc(100vh-100px)] pt-2 pb-1 grid grid-cols-12 gap-4 ">
          <div className=" col-span-2 bg-white h-full rounded-md overflow-hidden px-2 pt-4 shadow-box">
            <ul className="">
              {LinkItem &&
                LinkItem.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      {GetAccess("admin_view") && (
                        <NavLink to={item?.link} >
                          <li className={`p-1.5 ${item?.link == pathFile ? "bg-navhover":""} my-0.5 text-xs 2xl:text-[13px] rounded-md hover:bg-navhover`}>
                            {item?.label}
                          </li>
                        </NavLink>
                      )}
                    </React.Fragment>
                  );
                })}
            </ul>
          </div>
          <div className=" col-span-10 bg-white h-full rounded-md overflow-hidden px-2 pt-4 shadow-box">
            <Outlet/>
          </div>
        </div>
      </div>
      <div className=" w-full h-5 ">
        <p className=" text-slate-400 text-center w-full text-xs">
          <span className=" text-[15px] font-medium">&copy;</span> {GetYear()}{" "}
          Metatron Infotech.
        </p>
      </div>
    </div>
  );
}

export default MainAdminSettings;
